import type { ContentCard } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSCTA, CMSHTML, CMSHeading, CMSImage, CMSPageSection } from '@swf/cms';

import styles from './CMSContentCard.scss';

const CMSContentCard: React.FC<ContentCard> = ({ variant, heading, body, image, cta }) => (
  <CMSPageSection
    contain
    grid
    columns={2}
    gridClassName={classNames(styles.container, variant === 'image' && styles[`${variant}First`])}
  >
    {(heading.title || body.content || cta.url) && (
      <div className={styles.content}>
        <CMSHeading {...heading} />
        <CMSHTML {...body} />
        <CMSCTA {...cta} />
      </div>
    )}
    {/* remove ? in  image?.asset after normalizing CS data*/}
    {image?.asset && <CMSImage {...image} className={styles.image} />}
  </CMSPageSection>
);

export default CMSContentCard;
